import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { parseMarkdown } from '../utilities/markdown-parse';
import accessibilityAttributes from './accessibility-attributes';
import getDefaultMessage from './default-messages';

class TranslatedCopy extends React.Component {
  static defaultProps = {
    tagName: 'span',
    showRadio: false,
    onClick: null,
  };
  constructor(props) {
    super();

    this.customProps = {};

    Object.keys(props).forEach((prop) => {
      if (accessibilityAttributes.includes(prop)) {
        this.customProps[prop] = props[prop];
      }
    });
  }

  render() {
    const {
      className,
      copyID,
      id,
      languageBundle,
      liClasses,
      linkClasses,
      onClick,
      realCountry,
      realLanguage,
      showRadio,
      spaceAfter,
      spaceBefore,
      tagName,
      ulClasses,
    } = this.props;

    try {
      const defaultMessage = getDefaultMessage('es', copyID);
      let message = copyID;

      if (languageBundle.hasOwnProperty(copyID)) {
        message = languageBundle[copyID];
      } else if (defaultMessage) {
        message = defaultMessage;
      }

      if (message.indexOf('plural') !== -1 || message.indexOf('{') !== -1) {
        const boldItems = message.match(/\*\*(.*?)\*\*/g);
        if (boldItems) {
          boldItems.forEach((boldItem, i) => {
            boldItem = boldItem.replace(/\*/g, '');
            message = message.replace(boldItems[i], `<strong>${boldItem}</strong>`);
          });
        }

        return (
          <FormattedMessage
            id={ copyID }
            tagName={ tagName }
            defaultMessage={ message }
            onClick={ this.props.onClick }
            values={ this.props }
          >
            { txt => <span className={ className } dangerouslySetInnerHTML={ { __html: txt } } /> }
          </FormattedMessage>
        );
      }

      const mdMessage = parseMarkdown(message, {
        className,
        id,
        language: realLanguage,
        liClasses,
        linkClasses,
        onClick,
        showRadio,
        storefront: realCountry,
        tagName,
        ulClasses,
      });

      if (mdMessage) {
        return mdMessage;
      } else {
        message = spaceBefore ? ` ${message}` : spaceAfter ? `${message} ` : message;

        return React.createElement(
          tagName,
          {
            className,
            id,
            onClick: this.props.onClick,
            ...this.customProps,
          },
          message
        );
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(`Could not retrieve ${copyID} from the language bundle`);
      return <span>{ copyID }</span>;
    }
  }
}

const mapStateToProps = state => {
  return {
    languageBundle: state.LanguageBundle.languageBundle,
    realCountry: state.LanguageBundle.country,
    realLanguage: state.Manage.language,
  };
};

const ConnectedTranslatedCopy = connect(mapStateToProps)(TranslatedCopy);

export default ConnectedTranslatedCopy;
